import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../config/firebase';
import { getSpotifyTokens } from '../utils/spotify-auth';
import { useAuthState } from 'react-firebase-hooks/auth';

export default function SpotifyCallback() {
  const navigate = useNavigate();
  const [user, loading] = useAuthState(auth);
  const hasAttemptedRef = useRef(false);
  const code = new URLSearchParams(window.location.search).get('code');

  useEffect(() => {
    async function handleCallback() {
      if (hasAttemptedRef.current || loading || !user || !code) return;
      hasAttemptedRef.current = true;

      try {
        const tokenData = await getSpotifyTokens(code);
        const userResponse = await fetch('https://api.spotify.com/v1/me', {
          headers: {
            'Authorization': `Bearer ${tokenData.access_token}`
          }
        });

        if (!userResponse.ok) {
          throw new Error('Failed to fetch user profile');
        }

        navigate('/dashboard');
      } catch (err) {
        console.error('Error in Spotify callback:', err);
      }
    }

    handleCallback();
  }, [user, loading, code, navigate]);

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-md">
        <h1 className="text-xl font-bold mb-4">Connecting to Spotify...</h1>
        <p>Please wait while we complete the connection.</p>
      </div>
    </div>
  );
}